module.exports = __webpack_public_path__ + "static/save-e5fab62ceaf5705f5eb5efaa5aaa605a.jpg";